import { Select, DatePicker } from "antd";
import { useFormattedEmployees, useFormattedExcluedEmployeesOptions } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Search } from "react-feather";
const { RangePicker } = DatePicker;
import dayjs from "dayjs";
import { useFormContext } from "react-hook-form";
import { encrypt } from "core/Operations/cryptHelper";
const TimelogFilterSection = ({
  companyCode,
  locationCode,
  filterData,
  setFilterData,
  refetchTimeLogHandler,
  setSearchParams,
}) => {
  const employeeOptions = useFormattedExcluedEmployeesOptions({
    companyCode: companyCode,
    locationCode: locationCode,
    departmentCode: 0,
  });

  const [tempFilter, setTempFilter] = useState(filterData || {});
  const updateQueryParams = (key, value) => {
    if (key == null || value == null) {
      console.error("Key and value must not be null");
      return;
    }
    setTempFilter((prev) => {
      if (!prev) {
        console.error("Previous filter data is null");
        return { [key]: value };
      }
      return { ...prev, [key]: value };
    });
  };
  const searchHandler = () => {

    encrypt
    try {
      const encryptedParams = Object.keys(tempFilter || {}).reduce((acc, key) => {
        const val = tempFilter[key];
        if (val === null || val === undefined) {
          acc[key] = val;
        } else if (typeof val === "object") {
          acc[key] = encrypt(JSON.stringify(val));
        } else {
          acc[key] = encrypt(String(val));
        }
        return acc;
      }, {});
      setSearchParams(encryptedParams);
    } catch (err) {
      console.error("Encryption failed:", err);
      // fallback to unencrypted params if encryption fails
      setSearchParams({ ...tempFilter });
    }

    if (JSON.stringify(tempFilter) === JSON.stringify(filterData)) {
      refetchTimeLogHandler();
    } else {
      setFilterData(tempFilter);
    }
  };
  return (
    <>
      <div className="page-btn">
        <Select
          placeholder="Select employees"
          className="select "
          options={employeeOptions}
          onChange={(selectedOptions) => {
            updateQueryParams("employeeCode", selectedOptions);
          }}
          showSearch
          defaultValue={
            tempFilter?.employeeCode !== 0 ? tempFilter?.employeeCode : ""
          }
          style={{ width: "200px", fontSize: "12px", height: "30px" }}
          allowClear
          size="large"
          onClear={() => {
            updateQueryParams("employeeCode", 0);
          }}
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        />
      </div>

      <div className="page-btn">
        <RangePicker
          className="form-control"
          style={{ display: "flex", fontSize: "12px", height: "30px" }}
          onChange={(date, dateFormat) => {
            updateQueryParams("fromDate", dateFormat[0]);
            updateQueryParams("toDate", dateFormat[1]);
          }}
          defaultValue={[
            dayjs(tempFilter?.fromDate, "YYYY-MM-DD"),
            dayjs(tempFilter?.toDate, "YYYY-MM-DD"),
          ]}
          allowClear={false}
          getPopupContainer={(trigger) => trigger.parentNode}
          disabledDate={(current) => {
            return current && current > dayjs().startOf("day");
          }}
        />
      </div>

      <div className="page-btn">
        <button
          type="button"
          className="btn btn-added"
          onClick={searchHandler}
          style={{
            display: "inline",
            height: "30px",
            fontSize: "12px",
          }}
        >
          <Search size={15} />
        </button>
      </div>
    </>
  );
};

export default React.memo(TimelogFilterSection);

TimelogFilterSection.propTypes = {
  companyCode: PropTypes.any,
  locationCode: PropTypes.string.isRequired,
  filterData: PropTypes.object.isRequired,
  setFilterData: PropTypes.func.isRequired,
  refetchTimeLogHandler: PropTypes.func.isRequired,
  setSearchParams: PropTypes.func.isRequired,
};
